import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import { PlannerProfileListSearchCriteria } from '../../../../../models/planner-profile.model';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../../common/models';
import { ListSearchCriteriaFacade } from '../../../../list-search-criteria/list-search-criteria.facade';
import { ListSearchCriteriaType } from '../../../../list-search-criteria';

import { FailedMessagesProfileItemModel } from '../../models/profile/failed-messages-profile-item.model';
import {
  FailedMessagesProfileListState,
  FailedMessagesProfileListStateModel,
} from './failed-messages-profile-list.state';
import {
  FailedMessagesProfileListLoad,
  FailedMessagesProfileListInitialState,
} from './failed-messages-profile-list.actions';

@Injectable({ providedIn: 'root' })
export class FailedMessagesProfileListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<FailedMessagesProfileListStateModel> = this.store.select(
    FailedMessagesProfileListState.getState,
  );
  items$: Observable<FailedMessagesProfileItemModel[]> = this.store.select(FailedMessagesProfileListState.getItems);
  loaded$: Observable<boolean> = this.store.select(FailedMessagesProfileListState.getLoaded);

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.FailedMessagesProfiles)
      .subscribe((searchCriteria: PlannerProfileListSearchCriteria) => {
        this.store.dispatch(new FailedMessagesProfileListLoad(searchCriteria));
      });
  }

  loadListForDialog(searchCriteria: PlannerProfileListSearchCriteria): void {
    this.store.dispatch(new FailedMessagesProfileListLoad(searchCriteria));
  }

  setInitialState(): void {
    this.store.dispatch(new FailedMessagesProfileListInitialState());
  }
}
